import 'eonasdan-bootstrap-datetimepicker';
import moment from 'moment';
import { pageLang } from '../services/app-storage';

export function addDatePicker($el: JQuery, options: {
    minimum?: moment.Moment
} = {}): JQuery {
    if ($el.length > 0) {
        $el.datetimepicker({
            locale: pageLang,
            format: 'll',
            minDate: options.minimum
        });
        $el.data('DateTimePicker').clear();
        $el.val('');
    }

    return $el;
}

export function addDateTimePicker($el: JQuery, options: {
    minimum?: moment.Moment
} = {}): JQuery {
    if ($el.length > 0) {
        $el.datetimepicker({
            locale: pageLang,
            format: 'lll',
            minDate: options.minimum
        });
        $el.data('DateTimePicker').clear();
        $el.val('');
    }

    return $el;
}

export function addTimePicker($el: JQuery, options: {
    minimum?: moment.Moment
} = {}): JQuery {
    if ($el.length > 0) {
        $el.datetimepicker({
            locale: pageLang,
            format: 'LT',
            minDate: options.minimum
        });
        $el.data('DateTimePicker').clear();
        $el.val('');
    }

    return $el;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/datepicker.ts